import React from 'react';
import { NavLink } from 'react-router-dom';
import './SubLinks.css';

function MinistryLinks() {
  return (
    <div className='links'>

      <ul className='sub-items'>
        
      <li className='sublink-header'>Ministries</li>
      <li>
        <NavLink to='/ministries/outreach' className={({ isActive }) => (isActive ? "link-active" : "sub-link")}>Outreach</NavLink>
        </li>
        <li>
        <NavLink to='/ministries/men' className={({ isActive }) => (isActive ? "link-active" : "sub-link")}>Men</NavLink>
        </li>
        <li>
        <NavLink to='/ministries/women'  className={({ isActive }) => (isActive ? "link-active" : "sub-link")}>Women</NavLink>
        </li>

        <li>
        <NavLink to='/ministries/youth-group' className={({ isActive }) => (isActive ? "link-active" : "sub-link")}>Youth Group</NavLink>
        </li>
        <li>
        <NavLink to='/ministries/childrens-ministry' className={({ isActive }) => (isActive ? "link-active" : "sub-link")}>Children's Ministry</NavLink>
        </li>
        <li>
        <NavLink to='/ministries/nursery' className={({ isActive }) => (isActive ? "link-active" : "sub-link")}>Nursery</NavLink>
        </li>
      </ul>
    </div>
  )
}

export default MinistryLinks
